export const TRANSPORT_VEHICLES = [
  {
    id: "t1",
    provider: "Teezy Rider",
    vehicle_type: "MPV",
    pickup_location: "Harbourbay Ferry Terminal",
    dropoff_location: "Southlinks Golf and Country Club",
    price: 20,
    duration_minutes: 30,
    max_passengers: 4,
    image: "/byd-m6.png",
    description: "Spacious 4 Seater MPV with air conditioning and ample luggage space — perfect for golfers with clubs.",
    available_times: ["07:00","07:30","08:00","08:30","09:00","09:30","10:00","10:30","11:00","12:00","13:00","13:30","14:00","14:30","15:00","15:30","16:00","16:30"],
    return_available_times: ["12:00","12:30","13:00","14:00","15:00","15:30","16:00","16:30","17:00","17:30","18:00","19:00"],
    amenities: ["Air Conditioning","Golf Bag Storage","USB Charging","Bottled Water"],
    supports_round_trip: true,
  },
  {
    id: "t2",
    provider: "Teezy Rider",
    vehicle_type: "MPV",
    pickup_location: "Harbourbay Ferry Terminal",
    dropoff_location: "Indah Puri Golf Course",
    price: 25,
    duration_minutes: 35,
    max_passengers: 4,
    image: "/byd-m6.png",
    description: "Spacious 4 Seater MPV with air conditioning and ample luggage space — perfect for golfers with clubs.",
    available_times: ["07:00","07:30","08:00","08:30","09:00","09:30","10:00","10:30","11:00","12:00","13:00","13:30","14:00","14:30","15:00","15:30","16:00","16:30"],
    return_available_times: ["12:00","12:30","13:00","14:00","15:00","15:30","16:00","16:30","17:00","17:30","18:00","19:00"],
    amenities: ["Air Conditioning","Golf Bag Storage","USB Charging","Bottled Water"],
    supports_round_trip: true,
  },
  {
    id: "t3",
    provider: "Teezy Rider",
    vehicle_type: "MPV",
    pickup_location: "Harbourbay Ferry Terminal",
    dropoff_location: "Padang Golf Sukajadi",
    price: 25,
    duration_minutes: 35,
    max_passengers: 4,
    image: "/byd-m6.png",
    description: "Spacious 4 Seater MPV with air conditioning and ample luggage space — perfect for golfers with clubs.",
    available_times: ["07:00","07:30","08:00","08:30","09:00","09:30","10:00","10:30","11:00","12:00","13:00","13:30","14:00","14:30","15:00","15:30","16:00","16:30"],
    return_available_times: ["12:00","12:30","13:00","14:00","15:00","15:30","16:00","16:30","17:00","17:30","18:00","19:00"],
    amenities: ["Air Conditioning","Golf Bag Storage","USB Charging","Bottled Water"],
    supports_round_trip: true,
  },
  {
    id: "t4",
    provider: "Teezy Rider",
    vehicle_type: "MPV",
    pickup_location: "Harbourbay Ferry Terminal",
    dropoff_location: "Batam Hills Golf Resort",
    price: 30,
    duration_minutes: 45,
    max_passengers: 4,
    image: "/byd-m6.png",
    description: "Spacious 4 Seater MPV with air conditioning and ample luggage space — perfect for golfers with clubs.",
    available_times: ["07:00","07:30","08:00","08:30","09:00","09:30","10:00","10:30","11:00","12:00","13:00","13:30","14:00","14:30","15:00","15:30","16:00","16:30"],
    return_available_times: ["12:00","12:30","13:00","14:00","15:00","15:30","16:00","16:30","17:00","17:30","18:00","19:00"],
    amenities: ["Air Conditioning","Golf Bag Storage","USB Charging","Bottled Water"],
    supports_round_trip: true,
  },
  {
    id: "t5",
    provider: "Teezy Rider",
    vehicle_type: "MPV",
    pickup_location: "Harbourbay Ferry Terminal",
    dropoff_location: "Batam Island Country Club",
    price: 35,
    duration_minutes: 50,
    max_passengers: 4,
    image: "/byd-m6.png",
    description: "Spacious 4 Seater MPV with air conditioning and ample luggage space — perfect for golfers with clubs.",
    available_times: ["07:00","07:30","08:00","08:30","09:00","09:30","10:00","10:30","11:00","12:00","13:00","13:30","14:00","14:30","15:00","15:30","16:00","16:30"],
    return_available_times: ["12:00","12:30","13:00","14:00","15:00","15:30","16:00","16:30","17:00","17:30","18:00","19:00"],
    amenities: ["Air Conditioning","Golf Bag Storage","USB Charging","Bottled Water"],
    supports_round_trip: true,
  },
  {
    id: "t6",
    provider: "Teezy Rider",
    vehicle_type: "MPV",
    pickup_location: "Harbourbay Ferry Terminal",
    dropoff_location: "Palm Springs Golf & Beach Resort",
    price: 35,
    duration_minutes: 55,
    max_passengers: 4,
    image: "/byd-m6.png",
    description: "Spacious 4 Seater MPV with air conditioning and ample luggage space — perfect for golfers with clubs.",
    available_times: ["07:00","07:30","08:00","08:30","09:00","09:30","10:00","10:30","11:00","12:00","13:00","13:30","14:00","14:30","15:00","15:30","16:00","16:30"],
    return_available_times: ["12:00","12:30","13:00","14:00","15:00","15:30","16:00","16:30","17:00","17:30","18:00","19:00"],
    amenities: ["Air Conditioning","Golf Bag Storage","USB Charging","Bottled Water"],
    supports_round_trip: true,
  },
];
